import { NextRouter } from 'next/router';
import { KeyboardEvent, SetStateAction } from 'react';

const handleKeyDown = async (
  event: KeyboardEvent<HTMLDivElement>,
  push: NextRouter['push'],
  setShowResult?: (value: SetStateAction<boolean>) => void
) => {
  if (event.key === 'Enter') {
    const query = (event.target as HTMLInputElement).value;
    if (setShowResult) {
      setShowResult(false);
    }
    await push(`/search?search=${query}`);
  }
};

export default handleKeyDown;
